import React from 'react';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer
} from 'recharts';

import theme from '../../theme';


const chartSettings = {
  fontSize: '12px',
}

const LineChartSimple = ({ chartData, currentavgSearches, settings }) => {

  const maxYValue = chartData && Math.max(...chartData.map(dataItem => dataItem[settings.ykey]));
  const minYValue = chartData && Math.min(...chartData.map(dataItem => dataItem[settings.ykey]));

  return (
    <>
      <ResponsiveContainer width="100%" height={300} >
        <LineChart
          data={chartData}
          margin={{
            top: 20,
            right: 50,
            left: 20,
            bottom: 20,
          }}
        >
          <CartesianGrid
            vertical={false}
            stroke={theme.palette.grey.w400}
            strokeDasharray="2 4"
          />

          <XAxis dataKey={settings.xkey} tickSize={10} fontSize={chartSettings.fontSize} />
          <YAxis dataKey={settings.ykey} tickLine={false} fontSize={chartSettings.fontSize} domain={[minYValue, maxYValue]} />
          <Tooltip />
          <Legend />

          {/* <ReferenceLine
            y={currentavgSearches}
            stroke={theme.palette.warning.main}
            strokeWidth={2}
            label={{
              value: currentavgSearches,
              position: 'bottom',
              fill: theme.palette.warning.main,
              fontSize: chartSettings.fontSize
            }}
          /> */}

          <Line
            type="monotone"
            dataKey={settings.ykey}
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            activeDot={{ r: 6 }}
            dot={false}
          />

        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default LineChartSimple;